import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PaymentState } from '@store/reducers/payment.reducer';

export const selectPaymentState = createFeatureSelector<PaymentState>('payment');

// Config
export const selectConfigStatus = createSelector(selectPaymentState, s => s.configStatus);
export const selectConfigError  = createSelector(selectPaymentState, s => s.configError);
export const selectClientToken  = createSelector(selectPaymentState, s => s.clientToken);
export const selectPriceId      = createSelector(selectPaymentState, s => s.priceId);
export const selectIsSandbox    = createSelector(selectPaymentState, s => s.isSandbox);

// Has Paid
export const selectHasPaidStatus = createSelector(selectPaymentState, s => s.hasPaidStatus);
export const selectHasPaid       = createSelector(selectPaymentState, s => s.hasPaid);

// Verify
export const selectVerifyStatus = createSelector(selectPaymentState, s => s.verifyStatus);
export const selectVerifyError  = createSelector(selectPaymentState, s => s.verifyError);
